const MemberAttendanceReportActionTypes = {
	/** ***************** GET MEMBER ATTENDANCE REPORT START *********************** */
	GET_MEMBER_ATTENDANCE_REPORT_LIST_START: 'GET_MEMBER_ATTENDANCE_REPORT_LIST_START',
	GET_MEMBER_ATTENDANCE_REPORT_LIST_SUCCESS: 'GET_MEMBER_ATTENDANCE_REPORT_LIST_SUCCESS',
	GET_MEMBER_ATTENDANCE_REPORT_LIST_FAILURE: 'GET_MEMBER_ATTENDANCE_REPORT_LIST_FAILURE',
	GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_RESET:
		'GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_RESET',
	GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED:
		'GET_MEMBER_ATTENDANCE_REPORT_LIST_RESPONSE_CHANGED',

	/** ***************** FETCH MEMBER ATTENDANCE REPORT EXCEL DETAILS START *********************** */
	GET_MEMBER_ATTENDANCE_REPORT_EXCEL_START: 'GET_MEMBER_ATTENDANCE_REPORT_EXCEL_START',
	GET_MEMBER_ATTENDANCE_REPORT_EXCEL_SUCCESS: 'GET_MEMBER_ATTENDANCE_REPORT_EXCEL_SUCCESS',
	GET_MEMBER_ATTENDANCE_REPORT_EXCEL_FAILURE: 'GET_MEMBER_ATTENDANCE_REPORT_EXCEL_FAILURE',
	GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_RESET:
		'GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_RESET',
	GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_CHANGED:
		'GET_MEMBER_ATTENDANCE_REPORT_EXCEL_RESPONSE_CHANGED',
};
export default MemberAttendanceReportActionTypes;
